export default {
  alert: '',
};
